import * as React from 'react';
import shouldFlipBG from '../utils/should-flip-bg';

interface CheckBoxProps {
  name: string;
  label: string;
  description?: React.ReactNode;
  value: string;
  id: string;
  checked?: boolean;
  focus?: boolean;
  hideCheck?: boolean;
  labelOnBottom?: boolean;
  onChange?: Function;
  onBlur?: Function;
  theme?: 'night' | 'day';
  disabled?: boolean;
  required?: boolean;
}
interface CheckBoxState {
  flipBg: string;
}

export default function CheckBox(props: CheckBoxProps) {
  const inputEl: any = React.useRef(null);
  const { theme = 'day' } = props;
  const inputElParent: any = React.useRef(null);

  React.useEffect(() => {
    if (props.focus && inputEl && inputEl.current) {
      inputEl.current.focus();
    }
  }, [props.focus]);

  const [state, setState] = React.useState<CheckBoxState>({
    flipBg: ''
  });

  const handleMouseDown = () => {
    if (inputElParent.current) {
      inputElParent.current.classList.add('using-mouse');
    }
  };

  const handleKeyDown = (e: any) => {
    if (inputElParent.current) {
      if (e.keyCode === 9) {
        inputElParent.current.classList.remove('using-mouse');
      }
    }
  };

  React.useEffect(() => {
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('keydown', handleKeyDown);
  }, [props]);

  React.useEffect(() => {
    if (state.flipBg === '' && shouldFlipBG(inputElParent, theme)) {
      setState({
        ...state,
        flipBg: ' flipbg'
      });
    }
  }, []);

  return (
    <div
      ref={inputElParent}
      className={`input-field ${theme}${state.flipBg}${
        props.disabled ? ' disabled' : ''
      }
      `}
    >
      {!props.hideCheck && (
        <input
          type="checkbox"
          value={props.value}
          id={props.id}
          className={theme}
          name={props.name}
          ref={inputEl}
          checked={props.checked}
          disabled={props.disabled}
          required={props.required}
          onBlur={(e: any) => {
            if (props.onBlur !== undefined) {
              props.onBlur(e);
            }
          }}
          onChange={(e: any) => {
            if (props.onChange !== undefined) {
              props.onChange(e);
            }
          }}
        />
      )}
      <div className="text">
        {props.labelOnBottom ? (
          <>
            {props.description && (
              <span className="description">{props.description}</span>
            )}
            {props.label && (
              <label className="value" htmlFor={props.id}>
                {props.label}
              </label>
            )}
          </>
        ) : (
          <>
            {props.label && (
              <label
                className={`value ${props.checked ? 'checked' : ''}`}
                htmlFor={props.id}
              >
                {props.label}
              </label>
            )}
            {props.description && (
              <span className="description">{props.description}</span>
            )}
          </>
        )}
      </div>
      <div className="icon"></div>
    </div>
  );
}
